import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPersonaAnalytics = {
  name: "getPersonaAnalytics" as const,
  input: z.object({
    personaId: zExt.objectId(),
    daysBack: z.number().default(90),
  }),
  output: z.object({
    totalRevenue: z.number(),
    totalOrders: z.number(),
    avgOrderValue: z.number(),
  }),
};
